import React from 'react'
import { Button } from 'reactstrap'
import ErrorBoundary from 'components/ErrorBoundary'
import Loading from 'components/Loading/Loading'

interface ContractLineNotFoundProps {
  isLoading: boolean
  onBackToSearch: () => void
}

const ContractLineNotFound: React.FC<ContractLineNotFoundProps> = ({
  isLoading,
  onBackToSearch,
}) => {
  return (
    <ErrorBoundary>
      <Loading isLoading={isLoading} />
      <p>Contract line not found</p>
      <Button color="primary" onClick={onBackToSearch} outline>
        <i className="fas fa-chevron-left" />
        &nbsp; Back to Search
      </Button>
    </ErrorBoundary>
  )
}

export default ContractLineNotFound
